/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateCustomFieldDefinitionInput = {
    key?: string | null | undefined;
    displayName?: string | null | undefined;
    readOnly?: boolean | null | undefined;
    type?: string | null | undefined;
    entityType?: string | null | undefined;
    avaRef?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateCustomFieldDefinitionMutationVariables = {
    input: CreateCustomFieldDefinitionInput;
};
export type CreateCustomFieldDefinitionMutationResponse = {
    readonly createCustomFieldDefinition: {
        readonly customFieldDefinition: {
            readonly node: {
                readonly id: string;
                readonly key: string | null;
                readonly displayName: string | null;
                readonly readOnly: boolean | null;
                readonly entityType: string | null;
                readonly avaRef: number | null;
                readonly type: string | null;
            } | null;
        } | null;
    } | null;
};
export type CreateCustomFieldDefinitionMutation = {
    readonly response: CreateCustomFieldDefinitionMutationResponse;
    readonly variables: CreateCustomFieldDefinitionMutationVariables;
};



/*
mutation CreateCustomFieldDefinitionMutation(
  $input: CreateCustomFieldDefinitionInput!
) {
  createCustomFieldDefinition(input: $input) {
    customFieldDefinition {
      node {
        id
        key
        displayName
        readOnly
        entityType
        avaRef
        type
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCustomFieldDefinitionInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "createCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCustomFieldDefinitionMutation(\n  $input: CreateCustomFieldDefinitionInput!\n) {\n  createCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        key\n        displayName\n        readOnly\n        entityType\n        avaRef\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0886eed0712cb55f6bba94a46ac1abc8';
export default node;
